jQuery( document ).ready(function($) {    

    $('.has-children').click(function(e){
        e.preventDefault();
        
        $('.has-children').not(this).next('.product-sub-menu').slideUp();
        $('.has-children').not(this).removeClass('active');
        $('.has-children').not(this).find('.dropdown-toggle').removeClass('active');
        //$('.dropdown-toggle').removeClass('active');

       
        $(this).next('.product-sub-menu').slideToggle();
        
        
        $(this).attr('aria-expanded', function (i, attr) {
            return attr == 'true' ? 'false' : 'true'
        });
        
        $(this).toggleClass('active');
        $(this).find('.dropdown-toggle').toggleClass('active');
        //$(this).children('.dropdown-toggle').toggleClass('active');
        
       
    });
    
   
});
